export type ActivityLogModuleProps = {
  value: string;
  label: string;
};

export const activityLogModules: ActivityLogModuleProps[] = [
  { value: "DiesPurchase", label: "ડાઈ ખરીદી" },
  { value: "DiesPurchaseItem", label: "ડાઈ ખરીદી આઈટમ" },
  { value: "DiesSale", label: "ડાઈ વેચાણ" },
  { value: "DiesSaleItem", label: "ડાઈ વેચાણ આઈટમ" },
  { value: "WaxPurchase", label: "વેક્સ ખરીદી" },
  { value: "WaxPurchaseItem", label: "વેક્સ ખરીદી આઈટમ" },
  { value: "WaxSale", label: "વેક્સ વેચાણ" },
  { value: "WaxSaleItem", label: "વેક્સ વેચાણ આઈટમ" },
  { value: "Purchase", label: "ખરીદી" },
  { value: "PurchaseDetail", label: "ખરીદી બિલ આઈટમ" },
  { value: "PurchaseItems", label: "ખરીદી આઈટમ્સ" },
  { value: "Employees", label: "કામદાર" },
  { value: "Salaries", label: "પગાર એકાઉન્ટ" },
  { value: "Attendance", label: "હાજરી" },
  { value: "Items", label: "આઈટમ્સ" },
  { value: "Size", label: "સાઈઝ" },
  { value: "ItemSize", label: "આઈટમ સાઈઝ ભાવ" },
  { value: "Material", label: "મટીરીયલ" },
  { value: "MaterialSize", label: "મટીરીયલ સાઈઝ" },
  { value: "MaterialOrder", label: "મટીરીયલ ઓર્ડર" },
  { value: "MaterialOrderItem", label: "મટીરીયલ ઓર્ડર આઈટમ" },
  { value: "MaterialPurchase", label: "મટીરીયલ ખરીદી" },
  { value: "MaterialPurchaseItem", label: "મટીરીયલ ખરીદી આઈટમ" },
  { value: "MaterialStockEntry", label: "મટીરીયલ સ્ટોક એન્ટ્રી" },
  { value: "CuttingOrder", label: "કટીંગ ઓર્ડર" },
  { value: "CuttingOrderItem", label: "કટીંગ ઓર્ડર આઈટમ" },
  { value: "CuttingOrderMaterial", label: "કટીંગ ઓર્ડર મોકલેલ મટીરીયલ" },
  { value: "CuttingReceive", label: "કટીંગ રિસીવ" },
  { value: "CuttingReceiveItem", label: "કટીંગ રિસીવ આઈટમ" },
  { value: "CuttingMaterialEntry", label: "કટીંગ બેલેન્સ એન્ટ્રી" },
  { value: "TurningOrder", label: "ટર્નિંગ ઓર્ડર" },
  { value: "TurningOrderItem", label: "ટર્નિંગ ઓર્ડર આઈટમ" },
  { value: "TurningReceive", label: "ટર્નિંગ રિસીવ" },
  { value: "TurningReceiveItem", label: "ટર્નિંગ રિસીવ આઈટમ" },
  { value: "VmcOrder", label: "VMC ઓર્ડર" },
  { value: "VmcOrderItem", label: "VMC ઓર્ડર આઈટમ" },
  { value: "VmcReceive", label: "VMC રિસીવ" },
  { value: "VmcReceiveItem", label: "VMC રિસીવ આઈટમ" },
  { value: "Category", label: "કેટેગરી" },
  { value: "Parties", label: "પાર્ટીઓ" },
  { value: "PartiesItems", label: "પાર્ટી ભાવ" },
  { value: "Payments", label: "પાર્ટી એકાઉન્ટ" },
  { value: "WaxAccounts", label: "પાર્ટી વેક્સ એકાઉન્ટ" },
  { value: "JobworksParties", label: "જોબ પાર્ટી" },
  { value: "JobworksPartiesItems", label: "જોબ પાર્ટી ભાવ" },
  { value: "JobworksPayments", label: "જોબ પાર્ટી એકાઉન્ટ" },
  { value: "JobworksWaxAccounts", label: "જોબ પાર્ટી વેક્સ એકાઉન્ટ" },
  { value: "PurchaseParties", label: "ખરીદી પાર્ટી" },
  { value: "PurchasePayments", label: "ખરીદી પાર્ટી એકાઉન્ટ" },
  { value: "Account", label: "રોજમેળ" },
  { value: "AccountType", label: "રોજમેળ પાર્ટીઓ" },
  { value: "User", label: "યુઝર" },
  { value: "Setting", label: "સેટિંગ્સ" },
];

export const activityLogModuleLabel = (name: string) =>
  activityLogModules.find(
    (activityLogModule) => activityLogModule.value === name
  )?.label || name;
